<template>
  <li :style="`--order:${order?.header ?? 99}`">
    <span
      v-if="title !== 'Independent'"
      class="menu-label is-bolder"
    >
      {{ title }}
    </span>
    <ul>
      <NavigationItem
        v-for="(route, j) in routes"
        :key="`item-${j}`"
        :route="route"
        :item-order="order?.items[route.text] ?? 99"
      />
    </ul>
  </li>
</template>

<script>
import NavigationItem from '@/components/Navigation/NavigationItem.vue';

export default {
  name: 'NavigationSection',
  components: {
    NavigationItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    routes: {
      type: Array,
      required: true,
    },
    order: {
      type: Object,
      default: null,
    },
  },
};
</script>
